import {
  TOGGLE_ASIDE_NAVIGATION,
  TOGGLE_CLASS_ASIDE,
  CRASH_API,
  CRASH_API_DELETE,
  CRASH_API_REVIVE,
  FETCH_USER_PERMISSIONS_SUCCESS,
  FETCH_COUNTRY,
  FETCH_COUNTRY_SUCCESS,
  FETCH_COUNTRY_FAILURE,
  FETCH_REGION_JSON,
  FETCH_REGION_JSON_SUCCESS,
  FETCH_REGION_JSON_FAILURE,
  FETCH_COUNTRIES_JSON,
  FETCH_COUNTRIES_JSON_SUCCESS,
  FETCH_COUNTRIES_JSON_FAILURE,
  FETCH_TESTIMONIAL_COUNTRIES_JSON,
  FETCH_TESTIMONIAL_COUNTRIES_JSON_SUCCESS,
  FETCH_TESTIMONIAL_COUNTRIES_JSON_FAILURE,
} from "./actionType";
import { LOGOUT_USER } from "../authentication/actionType";

const initialState = {
  message: "",
  selectedMenu: "",
  enableAside: false,
  toggleAsideNavigation: false,
  crash_api: null,
  flag: 0,
  permissions: {
    isReadOnly: "",
  },
  config: {},
  countries: [],
  regionJson: {},
  tourCountriesJson: [],
  testimonialCountriesJson: null,
};

function goalReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CLASS_ASIDE:
      return {
        ...state,
        enableAside: action.payload.enableAside,
        selectedMenu: action.payload.selectedMenu,
      };
    case LOGOUT_USER:
      return {
        ...state,
        ...initialState,
      };
    case TOGGLE_ASIDE_NAVIGATION:
      return {
        ...state,
        toggleAsideNavigation: true,
      };
    case CRASH_API:
      return {
        ...state,
        crash_api: action.payload,
      };
    case CRASH_API_DELETE:
      return {
        ...state,
        crash_api: null,
      };
    case CRASH_API_REVIVE:
      return {
        ...state,
        // crash_api: null
      };
    case FETCH_USER_PERMISSIONS_SUCCESS:
      var permission = { isReadOnly: action.user.isReadOnly };
      return {
        ...state,
        permissions: permission,
      };

    case FETCH_COUNTRY:
      return {
        ...state,
        countries: [],
      };
    case FETCH_COUNTRY_SUCCESS:
      return {
        ...state,
        countries: action.payload,
      };

    case FETCH_COUNTRY_FAILURE:
      return {
        ...state,
        countries: [],
      };

    case FETCH_REGION_JSON:
      return {
        ...state,
        regionJson: {},
      };
    case FETCH_REGION_JSON_SUCCESS:
      return {
        ...state,
        regionJson: action.payload,
      };

    case FETCH_REGION_JSON_FAILURE:
      return {
        ...state,
        regionJson: {},
      };

    case FETCH_COUNTRIES_JSON:
      return {
        ...state,
        tourCountriesJson: {},
      };
    case FETCH_COUNTRIES_JSON_SUCCESS:
      return {
        ...state,
        tourCountriesJson: action.payload,
      };

    case FETCH_COUNTRIES_JSON_FAILURE:
      return {
        ...state,
        tourCountriesJson: {},
      };

    case FETCH_TESTIMONIAL_COUNTRIES_JSON:
      return {
        ...state,
        testimonialCountriesJson: {},
      };
    case FETCH_TESTIMONIAL_COUNTRIES_JSON_SUCCESS:
      return {
        ...state,
        testimonialCountriesJson: action.payload,
      };

    case FETCH_TESTIMONIAL_COUNTRIES_JSON_FAILURE:
      return {
        ...state,
        testimonialCountriesJson: {},
      };

    default:
      return state;
  }
}

export default goalReducer;
